import { useEffect, useState } from 'react';
import useSWR from 'swr';
import { debounce } from 'lodash';
import { OrderService, PhoneSuggestionData } from '../../../../../api';

const MIN_PHONE_DIGITS = 4;
const DEBOUNCE_MS = 300;

type UsePhoneSuggestionsResult = {
  suggestions: PhoneSuggestionData[];
  isLoading: boolean;
};

const suggestionsFetcher = async ({ phonePrefix }: { opId: string; phonePrefix: string }) =>
  OrderService.getPhoneSuggestions(phonePrefix);

const countDigits = (value: string) => value.replace(/\D/g, '').length;

export const usePhoneSuggestions = (phone: string): UsePhoneSuggestionsResult => {
  const [debouncedPhone, setDebouncedPhone] = useState(phone);

  useEffect(() => {
    const updateDebouncedPhone = debounce((value: string) => setDebouncedPhone(value), DEBOUNCE_MS);
    updateDebouncedPhone(phone);
    return () => updateDebouncedPhone.cancel();
  }, [phone]);

  const { data, isLoading } = useSWR(
    countDigits(debouncedPhone) >= MIN_PHONE_DIGITS
      ? { opId: 'getPhoneSuggestions', phonePrefix: debouncedPhone }
      : null,
    suggestionsFetcher,
    {
      revalidateOnFocus: false,
    },
  );

  return {
    suggestions: data ?? [],
    isLoading,
  };
};
